import {
  NotificationIcon as CoreNotificationIcon,
  useSession,
} from '@zhiyue/core';
import React from 'react';
import { fetchOpenPlatformToken } from '@/services/openPlatformToken';
import { hasOAuth2Session } from '@/services/oauth2';

type NotificationIconProps = Omit<
  React.ComponentProps<typeof CoreNotificationIcon>,
  'token'
>;

const NotificationIcon: React.FC<NotificationIconProps> = (props) => {
  const { currentUser, loading } = useSession();
  const userContext = currentUser as
    | (typeof currentUser & { organizationUuid?: string })
    | undefined;
  const [token, setToken] = React.useState<string>();

  React.useEffect(() => {
    if (
      loading ||
      !currentUser?.memberUuid ||
      !userContext?.tenantUuid ||
      !userContext.organizationUuid ||
      !hasOAuth2Session()
    ) {
      setToken(undefined);
      return;
    }

    let active = true;
    setToken(undefined);
    fetchOpenPlatformToken(userContext)
      .then(({ accessToken }) => {
        if (active) {
          setToken(accessToken);
        }
      })
      .catch(() => {
        if (active) {
          setToken(undefined);
        }
      });

    return () => {
      active = false;
    };
  }, [
    currentUser?.memberUuid,
    userContext?.tenantUuid,
    userContext?.organizationUuid,
    loading,
  ]);

  if (loading || !currentUser?.memberUuid || !currentUser?.tenantUuid || !token) {
    return null;
  }

  return <CoreNotificationIcon {...props} token={token} />;
};

export default NotificationIcon;
